import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class TaxConfirmationCriteria extends Model.CriteriaBase {
    static typeName = "TaxConfirmationCriteria";

    constructor() {
        super();
        this.makeObservable();

        const today = DateUtils.today();
        this.startDate = new Date(today.getFullYear() - (today.getMonth() >= 2 ? 1 : 2), 2, 1);
        this.endDate = DateUtils.add(DateUtils.add(this.startDate, { years: 1 }), { days: -1 });
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.today();

    @Attributes.Nullable()
    public investorId: number | null = null;

    public investorInvestmentId: number = 0;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<TaxConfirmationCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Tax Confirmation Criteria";
    }
}